import { CustomType, UserDailyDiaryProgress } from '../../services/api.types'
import { t } from 'ttag'
import moment from 'moment'
import { formatThousands } from '../../common/helpers/translations'
import * as React from 'react'
import './YumCustomTable.scss'
import { getLongDateString } from '../../common/helpers/date'
import { isRtl } from '../../i18nInit'
import { ReactComponent as CheckIcon } from '../../assets/v3/icons/check.svg'

export interface IStateProps {
  data: UserDailyDiaryProgress[]
  valueGoal: number
  units: string
  manualEntryEnabled: boolean
  showDigits?: boolean
  suffix?: string
  showTotalSum?: boolean
  showSeparateValues?: boolean
  isBinary?: boolean
}

export default function YumLogTable(props: IStateProps) {
  const {
    data,
    valueGoal,
    units,
    manualEntryEnabled,
    showDigits,
    suffix,
    showTotalSum,
    showSeparateValues: showSeparateValuesRaw,
    isBinary,
  } = props

  const valueBEM = (met: boolean) => {
    const base = 'data-item__value'
    const classArray = [base]
    if (met) {
      classArray.push(`${base}--met`)
    }
    return classArray.join(' ')
  }

  const anyIntegrationValues = data && !!data.find(({ integrationValue }) => integrationValue > 0)
  const anyManualValues = data && !!data.find(({ manualValue }) => manualValue > 0)
  const showSeparateValues = manualEntryEnabled && (anyIntegrationValues || showSeparateValuesRaw) && anyManualValues

  const today = new Date()
  const relevantData = data ? data.filter(({ date }) => moment(date).isBefore(today)) : []
  let totalSum = showTotalSum && data ? relevantData.reduce((a, { sum }) => a + sum, 0) : null
  if (showTotalSum && totalSum && suffix === '%') {
    totalSum = Math.floor(totalSum / relevantData.length)
  }

  return (
    <table className={'custom-table custom-table__me'}>
      <thead>
        <tr>
          <th>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.4 4.8C6.4 3.91875 7.11563 3.2 8 3.2C8.88438 3.2 9.6 3.91875 9.6 4.8V6.4H11.2C12.0844 6.4 12.8 7.11875 12.8 8C12.8 8.88125 12.0844 9.6 11.2 9.6H8C7.11563 9.6 6.4 8.88125 6.4 8V4.8Z"
                fill="#006FFF"
              />
            </svg>
            {t`Date`}
          </th>
          {showSeparateValues && (
            <th className={'data-item__value data-item__value--center'}>
              {t`Integration`}
              <br />
              <span className={'opacity-50'}>{t`Manual entry`}</span>
            </th>
          )}
          <th className={'data-item__value'}>{isBinary ? t`Done` : units}</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map(
            ({ date, integrationValue, manualValue, sum }, keyIndex) =>
              moment(date).isBefore(today) && (
                <tr key={keyIndex}>
                  <td>
                    <div className={'data-item__day'}>{moment(date).format('dddd')}</div>
                    <div className={'data-item__date'}>{getLongDateString(moment(date).toDate())}</div>
                  </td>
                  {showSeparateValues && (
                    <td className={'data-item__value data-item__value--center'}>
                      {formatThousands(integrationValue, showDigits ? 2 : 0)}
                      {suffix}
                      <br />
                      <span className={'opacity-50'}>
                        {formatThousands(manualValue, showDigits ? 2 : 0)}
                        {suffix}
                      </span>
                    </td>
                  )}
                  {manualEntryEnabled && (
                    <td className={valueBEM(sum >= valueGoal)}>
                      {!isBinary ? (
                        <>
                          {formatThousands(sum, showDigits ? 2 : 0)}
                          {suffix}
                        </>
                      ) : (
                        <>{sum >= valueGoal ? <CheckIcon /> : '✕'}</>
                      )}
                    </td>
                  )}
                  {!manualEntryEnabled && (
                    <td className={valueBEM(integrationValue >= valueGoal)}>
                      {formatThousands(integrationValue, showDigits ? 2 : 0)}
                      {suffix}
                    </td>
                  )}
                </tr>
              ),
          )}
      </tbody>
      {totalSum ? (
        <tfoot style={{ opacity: 0.5 }}>
          <tr>
            <td></td>
            {showSeparateValues && <td></td>}
            <td className={valueBEM(false)}>
              {formatThousands(totalSum, showDigits ? 2 : 0)}
              {suffix}
            </td>
          </tr>
        </tfoot>
      ) : null}
    </table>
  )
}
